import { resolveFileUrl } from '@/components/shared/utils/fileUrl'

const BLOB_REVOKE_MS = 60 * 1000

/** 尽量改成当前站点同源路径，走 /files 代理 */
function toSameOriginUrl(url) {
  const resolved = resolveFileUrl(url)
  if (!resolved || resolved.startsWith('data:')) return resolved
  if (!/^https?:\/\//i.test(resolved)) return resolved
  try {
    const parsed = new URL(resolved)
    if (parsed.pathname.startsWith('/files/')) {
      return `${parsed.pathname}${parsed.search}`
    }
    if (typeof window !== 'undefined' && parsed.origin === window.location.origin) {
      return `${parsed.pathname}${parsed.search}${parsed.hash}`
    }
  } catch {
    return resolved
  }
  return resolved
}

function navigatePopup(win, href) {
  if (!win || win.closed) {
    window.open(href, '_blank', 'noopener,noreferrer')
    return
  }
  try {
    win.location.replace(href)
  } catch {
    win.location.href = href
  }
}

/** 新窗口以 blob 打开 PDF，避开 Chrome 对 HTTP 直链的提示 */
export async function openPdfBlob(url) {
  const fallback = resolveFileUrl(url)
  if (!fallback) return false
  const fetchUrl = toSameOriginUrl(fallback) || fallback
  const win = window.open('about:blank', '_blank')

  try {
    const response = await fetch(fetchUrl, { credentials: 'same-origin' })
    if (!response.ok) throw new Error(`pdf fetch ${response.status}`)
    const raw = await response.blob()
    const blob = raw.type === 'application/pdf'
      ? raw
      : new Blob([raw], { type: 'application/pdf' })
    const blobUrl = URL.createObjectURL(blob)
    navigatePopup(win, blobUrl)
    window.setTimeout(() => URL.revokeObjectURL(blobUrl), BLOB_REVOKE_MS)
    return true
  } catch {
    navigatePopup(win, fallback)
    return false
  }
}

/** 拦截正文内附件链接：blob 新窗口打开 */
export function handlePortalAttachmentLinkClick(event) {
  const link = event?.target?.closest?.('a[data-link-type="attachment"]')
  if (!link) return false
  const href = String(link.getAttribute('href') || '').trim()
  if (!href || href === '#') return false
  event.preventDefault()
  event.stopPropagation()
  openPdfBlob(href)
  return true
}

/** 为 v-csp-html 容器绑定附件链接点击 */
export function bindPortalAttachmentLinks(el) {
  if (!el || el.__portalAttachmentLinkBound) return
  el.__portalAttachmentLinkBound = true
  el.addEventListener('click', handlePortalAttachmentLinkClick)
}
